import { overmapReducers } from "@overmap-ai/core"
import { combineReducers } from "@reduxjs/toolkit"

import {
	appReducer,
	appSettingsReducer,
	appSettingsSlice,
	appSlice,
	filterSlice,
	filterSliceReducer,
	mapFilterSlice,
	mapFiltersReducer,
	mapVisibilityReducer,
	mapVisibilitySlice,
	sessionReducer,
	sessionSlice,
} from "./slices"

export const appReducers = {
	...overmapReducers,
	[appSlice.name]: appReducer,
	[appSettingsSlice.name]: appSettingsReducer,
	[filterSlice.name]: filterSliceReducer,
	[mapFilterSlice.name]: mapFiltersReducer,
	[mapVisibilitySlice.name]: mapVisibilityReducer,
	[sessionSlice.name]: sessionReducer,
} as const

export const rootReducer = combineReducers(appReducers)
